var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"mb-5"},[_c('b-embed',{attrs:{"type":"iframe","aspect":"4by3","src":"https://whatsapp-api-mark4.herokuapp.com/","allowfullscreen":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }